import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {TAlert, TSnackSlice} from "../types";
import {v4 as uuid} from "uuid";

const initialState: TSnackSlice = {
    notifications: [],

    alertNotifications: []
}

export const addErrorSnack = createAsyncThunk(
    'snack/addErrorSnack',
    async (payload: string | { message: string, invalidToken?: boolean }, {dispatch}): Promise<any> => {
        if (typeof payload === 'object') {
            // payload.invalidToken && setTokenMissing();
            return payload.message;
        }
        return payload;
    }
)

const snackSlice = createSlice({
    name: 'snack',
    initialState,
    reducers: {
        addInfoSnack: (slice, {payload}) => {
            slice.notifications = [...slice.notifications, {key: payload, message: payload, variant: "info"}]
        },
        addSuccessfulSnack: (slice, {payload}: {payload: string | {message: string}}) => {
            if (typeof payload === "string") slice.notifications = [...slice.notifications, {key: payload, message: payload, variant: "success"}]
            else slice.notifications = [...slice.notifications, {key: payload.message, message: payload.message, variant: "success"}]
        },
        removeSnack: (slice, {payload: id}) => {
            slice.notifications = slice.notifications.filter(note => note.key !== id)
        },

        addAlertAction: (slice: TSnackSlice, {payload}: {payload: TAlert}) => {
            slice.alertNotifications.push({...payload, key: uuid()})
        },
        removeAlertAction: (slice: TSnackSlice, {payload}: {payload: string}) => {
            const index = slice.alertNotifications.findIndex(e => e.key === payload);
            if (index > -1) slice.alertNotifications[index].isOpen = false;
        },
        removeAllAlertsAction: (slice: TSnackSlice) => {
            slice.alertNotifications = [];
        },
    },
    extraReducers: builder => {
        builder.addCase(addErrorSnack.fulfilled, (slice, {payload}) => {
            slice.notifications = [...slice.notifications, {key: payload, message: payload, variant: "error"}]
        })
    }
})

export const snackReducer = snackSlice.reducer;
export const {
    removeSnack, addInfoSnack, addSuccessfulSnack,
    addAlertAction, removeAlertAction, removeAllAlertsAction,
} = snackSlice.actions;

